<template>
  <v-dialog
    v-model="dialog"
    width="420px">
    <div class="dialog-container">
      <div class="plan-header">
        <div class="info flex">
          <h3>Vehicle Registration Document</h3>
          <i
            class="el-icon-close"
            @click="handleCancel"></i>
        </div>
      </div>
      <div class="dialog-body">
        <el-form
          ref="form"
          :rules="rules"
          :model="formData">
          <div class="form-item">
            <span>Vehicle Registration Document</span>
            <el-form-item
              ref="rgtn_pic_path_id"
              prop="rgtn_pic_path_id"
            >
              <v-upload
                :card="true"
                :fileData="formData.rgtn_pic"
                :otherData="{
                  target: 'rgtn_pic',
                  idKey: 'rgtn_pic_path_id',
                  nameKey: 'rgtn_pic_path'
                }"
                @delete="handlerDeleteFile"
                @uploadSuccess="handlerUploadSuccess"
              />
            </el-form-item>
          </div>
          <div
            class="form-item">
            <span>Registration Mark</span>
            <el-form-item
              ref="rgtn_no"
              prop="rgtn_no"
              :rules="formData.rgtn_pic_path_id?rules.input:null"
            >
              <v-input
                v-model="formData.rgtn_no"
                :uppercase="true"
                maxlength="8"
                type="text"/>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="dialog-footer">
        <v-button @click="handleCancel">Cancel</v-button>
        <v-button
          type="primary"
          @click="onContinue">Continue</v-button>
      </div>
    </div>

  </v-dialog>
</template>
<script>
import MixinRules from '@/mixins/rules'
import {updateOrderRgtn} from '@api/order'

export default {
  name: 'uploadVechicDialog',
  mixins: [MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    changeUploadData: {
      type: Object,
      default: () => ({})
    },
    value:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      formData: {
        rgtn_pic:{},
        rgtn_pic_path_id:'',
        rgtn_pic_path:'',
        rgtn_no:''
      },
    }
  },
  computed:{
    orderId(){
      let {id} = this.form
      return id||''
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dialog = val
        if(val) {
          let {rgtn_pic,rgtn_no} = this.form||{}
          const {path,id} = rgtn_pic||{}
          this.formData.rgtn_pic = rgtn_pic
          this.formData.rgtn_pic_path_id = id||''
          this.formData.rgtn_pic_path= path||''
          this.formData.rgtn_no = rgtn_no
        }
      }
    }
  },
  methods: {
    handleCancel() {
      this.$emit('input',false)
    },
    handlerUploadSuccess({ data, result,otherData }) {
      this.$set(this.formData, 'rgtn_pic', data)
      this.$set(this.formData, 'rgtn_pic_path_id', data.id)
      this.$set(this.formData, 'rgtn_pic_path', data.path)
      this.$refs['form'].clearValidate(['rgtn_pic_path'])
    },
    handlerDeleteFile() {
      this.$set(this.formData, 'rgtn_pic', null)
      this.$set(this.formData, 'rgtn_pic_path_id', '')
      this.$set(this.formData, 'rgtn_pic_path', '')
      this.$refs['form'].clearValidate(['rgtn_pic_path'])
    },
    onContinue() {
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          this.network().updateOrderRgtn()
        }
        else {
          console.log(rules)
        }
      })
    },
    network() {
      return {
        updateOrderRgtn: async () => {
          let params = {
            order_id: this.orderId,
            ...this.formData
          }
          const { data } = await updateOrderRgtn(params)

          this.dialog = false
          this.$emit('input',false)
          this.$emit('success', this.formData,this.formKey)

        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
  //padding: 15px;
  .plan-header {
    //padding: 15px;
    background: #F6F8FA;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .info{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:10px 10px 10px 10px;
      font-size: 14px;
      font-weight: 600;
      color: #24292E;
      i{
        font-weight: 600;
        font-size: 14px;
      }
      h3{
        padding-bottom: 0;
      }
    }
  }
  .dialog-footer {
    //margin: 15px -15px -15px;
    padding: 15px;
    text-align: right;
    background: #F9FAFB;
  }
  .form-item {
    & > span {
      font-weight: bold;
      font-size: 16px;
    }
  }
  .dialog-body{
    padding: 15px;
  }
}
</style>
